const MessageBubble = ({ role, content }) => {
  const isUser = role === 'user';

  if (isUser) {
    return (
      <div className="flex justify-end">
        <div className="max-w-[min(100%,48rem)] whitespace-pre-wrap break-words rounded-2xl border border-white/15 bg-white/10 px-4 py-3 text-sm text-white shadow-sm">
          {content}
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-start gap-3">
      <div className="flex h-8 w-8 items-center justify-center rounded-full border border-white/20 bg-white/10 text-[11px] font-semibold text-white">
        DX
      </div>
      <p className="max-w-4xl text-lg leading-relaxed text-white">{content}</p>
    </div>
  );
};

export default MessageBubble;
